// import Lottie from 'lottie-react';
// import mapLoadingAnimation from '@/public/map-loading.json';

interface MapLoadingProps {
  message?: string;
}

export default function MapLoading({ message = '読み込み中...' }: MapLoadingProps) {
  return (
    <div className="absolute inset-0 z-50 flex flex-col items-center justify-center bg-white/80">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      <span className="mt-4 text-gray-600">{message}</span>
      {/* <Lottie
        animationData={mapLoadingAnimation}
        loop={true}
        style={{ width: 100, height: 100 }}
      /> */}
      {/* <span className="mt-4 text-gray-600">{message}</span> */}
    </div>
  );
}